import { translateInComponent, translate } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import { getPlanName, PlanId } from 'domains/models/subscription/planId';
import {
  borderRadius,
  fontSize,
  fontWeight,
  spacing,
} from 'presentations/views/styles';
import Link from 'presentations/views/components/atoms/Link';
import { memo } from 'react';
import { blue03, primary } from 'presentations/views/styles/color';
import { PlanVersion } from 'domains/models/subscription/planVersion';

interface Props {
  className?: string;
  planId: PlanId;
  planVersion: PlanVersion;
  url?: string | null;
}

const Component = memo((props: Props) => {
  const t = translateInComponent(translations);
  return (
    <PlanName href={props.url || undefined} className={props.className}>
      {t('Plan name', {
        planName: getPlanName(props.planId, props.planVersion),
      })}
    </PlanName>
  );
});

const PlanName = styled(Link)`
  display: block;
  width: fit-content;
  border-radius: ${borderRadius(4)};
  padding: ${spacing(2)} ${spacing(8)};
  color: ${primary};
  background-color: ${blue03};
  font-size: ${fontSize(13)};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing(2)};
`;

export default Component;
